<!-- features/forms/page/form-upsert/form-upsert.html -->
@if (editingId) {
  <ui-organism-main-nav [mainText]="'forms.form.editTitle' | translate"> </ui-organism-main-nav>
} @else {
  <ui-organism-main-nav [mainText]="'forms.form.createTitle' | translate"> </ui-organism-main-nav>
}

<ui-atom-spacer />
<ui-atom-text type="medium" [text]="'forms.form.subtitle' | translate"> </ui-atom-text>
<ui-atom-spacer size="spacer-xxl" />

<section class="form-upsert-form">
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="form-upsert-form__grid"
    autocomplete="off"
  >
    <!-- Nombre del formulario -->
    <div class="form-upsert-form__field">
      <ui-molecule-input
        textId="name"
        formControlName="name"
        [label]="'forms.form.name.label' | translate"
        [placeholder]="'forms.form.name.placeholder' | translate"
        required="true"
      >
      </ui-molecule-input>

      <div
        class="ui-input-error-container"
        [class.hidden]="!nameControl?.touched || nameControl?.valid"
      >
        @if (nameControl?.hasError('required')) {
          <span>{{ 'forms.form.name.error.required' | translate }}</span>
        }
        @if (nameControl?.hasError('minlength')) {
          <span>{{ 'forms.form.name.error.minLength' | translate }}</span>
        }
        @if (nameControl?.hasError('maxlength')) {
          <span>{{ 'forms.form.name.error.maxLength' | translate }}</span>
        }
      </div>
    </div>

    <!-- Acciones -->
    <div class="form-upsert-form__actions">
      <ui-atom-button
        type="button"
        rules="main"
        styling="outlined"
        [withShadow]="false"
        [text]="'forms.form.actions.cancel' | translate"
        (click)="cancel()"
      >
      </ui-atom-button>

      <ui-atom-button
        type="button"
        rules="main"
        styling="filled"
        [withShadow]="true"
        [text]="
          editingId
            ? ('forms.form.actions.save' | translate)
            : ('forms.form.actions.create' | translate)
        "
        (click)="onSubmit()"
      >
      </ui-atom-button>
    </div>
  </form>
</section>
